import { useState } from "react";
import { cx } from "@/lib/cx";
import { initials } from "@/lib/format";

interface AvatarProps {
  name: string;
  size?: number;
  className?: string;
  brand?: boolean;
  /** Foto de perfil (ex.: WhatsApp); cai para as iniciais quando ausente ou falha ao carregar. */
  src?: string | null;
}

/**
 * Cores de peer avatar do Telegram Web K (`src/scss/base.scss`, mixin
 * `avatar-color`): par topo/base por nome, deterministico.
 */
const TG_AVATAR_COLORS: readonly (readonly [string, string])[] = [
  ["#ff845e", "#d45246"],
  ["#febb5b", "#f68136"],
  ["#b694f9", "#6c61df"],
  ["#9ad164", "#46ba43"],
  ["#53edd6", "#28c9b7"],
  ["#5caffa", "#408acf"],
  ["#ff8aac", "#d95574"],
];

export function avatarColors(name: string): readonly [string, string] {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return TG_AVATAR_COLORS[hash % TG_AVATAR_COLORS.length]!;
}

export function Avatar({ name, size = 44, className, brand, src }: AvatarProps) {
  const [top, bottom] = avatarColors(name);
  const [broken, setBroken] = useState(false);

  if (src && !broken) {
    return (
      <img
        src={src}
        alt=""
        aria-hidden="true"
        className={cx("row-avatar", className)}
        style={{ width: size, height: size, flex: `0 0 ${size}px`, objectFit: "cover" }}
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span
      className={cx("row-avatar", className)}
      style={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        fontSize: Math.max(11, Math.round(size * 0.36)),
        background: brand ? "var(--tg-primary-solid)" : `linear-gradient(${top}, ${bottom})`,
        color: "#fff",
      }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  );
}
